var EtlDetails = /** @class */ (function () {
    function EtlDetails(_a) {
        var id = _a.id, etl = _a.etl, destination = _a.destination, data = _a.data, charts = _a.charts;
        this.id = id;
        this.etl = etl;
        this.destination = destination;
        this.data = data;
        this.charts = charts;
    }
    EtlDetails.fromJSON = function (json) {
        var _a = Object.assign({}, json), id = _a.id, etl = _a.etl, destination = _a.destination, data = _a.data, charts = _a.charts;
        if (typeof id !== 'string')
            throw new Error('id must be a string');
        return new EtlDetails({
            id: id,
            etl: etl,
            destination: destination,
            data: data,
            charts: charts,
        });
    };
    return EtlDetails;
}());
export default EtlDetails;
